import React from "react"

import { Location } from "@tenforce/product-fields"

import { GlobalState } from "../../../../store"
import { useAppSelector } from "../../../../hooks"
import { ILocationField } from "../../index"

export interface Props {
    field: ILocationField
}

export const LocationField = ({ field }: Props): JSX.Element => {
    const { isLoading } = useAppSelector((state: GlobalState) => state.fields)

    const {
        position: _position,
        odataType: _odataType,
        value,
        ...fieldProps
    } = field

    const { marker, latitude, longitude } = value
        ? value
        : { marker: null, latitude: null, longitude: null }

    return (
        <Location
            {...fieldProps}
            isLoading={isLoading}
            latitude={latitude}
            longitude={longitude}
            marker={marker}
        />
    )
}

export default LocationField
